// Lightweight wrapper around gtag so components don't have to guard for
// `window.gtag` being undefined (e.g. ad-blockers, dev builds without GA).
export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;
  const gtag = window.gtag;
  if (typeof gtag !== "function") return;
  try {
    gtag("event", eventName, params);
  } catch (e) {
    // Analytics must never break UX — but log so a genuinely broken GA setup
    // is discoverable in dev / production console.
    console.warn("[analytics] trackEvent failed:", eventName, e);
  }
}

export function trackCtaClick(location, buttonText) {
  trackEvent("cta_click", {
    location,
    button_text: buttonText,
  });
}
